import { useEffect, useState } from 'react'

/**
 * Détecte si l'écran est de taille "mobile" (< breakpoint px).
 * Réactif au redimensionnement et à la rotation.
 */
export function useIsMobile(breakpoint = 768): boolean {
  const getMatch = () =>
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false

  const [isMobile, setIsMobile] = useState<boolean>(getMatch)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
    const onChange = () => setIsMobile(window.innerWidth < breakpoint)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [breakpoint])

  return isMobile
}
